<div fxLayout="column" fxLayoutAlign="center" class="user-admin-panel-container">
    <ng-container *ngIf="adminCapabilities|async as adminCaps">
        <ng-container *ngIf="canAdmin(adminCaps); else notEnoughPerms">
            <div fxLayout="row" fxLayoutAlign="center">
                <h2 class="mat-h2 text-primary">{{'User administration'|i18n}}</h2>
            </div>
            <lib-admin-panel [capabilities]="adminCaps"
                             [userFilter]="userFilter"
                             [show2FA]="true"
                             (infoMsg)="onInfoOccurred($event)"
                             (errorMsg)="onErrorOccurred($event)">
            </lib-admin-panel>
        </ng-container>
    </ng-container>
</div>

<ng-template #notEnoughPerms>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-16">
        {{'Insufficient permissions to administrate users'|i18n}}
    </div>
</ng-template>
